export default "__VITE_ASSET__aK0AdjvD__";